// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__ySjZ0","separatorWording":"Separator_separatorWording__LYwOU"};